export default "__VITE_ASSET__CIyidXA5__"